export const API_BASE_URL = "/api";
export const ACCESS_TOKEN = "authorizationToken";
export const BUGSNAG_KEY = "bugsnagkey";
export const AUTHENTICATED = "authenticated";
export const CURRENT_TENANT = "currentTenant";
export const TEMP_TENANT = "tempTenant";
export const TENANTS_LIST = "tenantsList";
export const TOTAL_TENANTS = "totalTenants";
export const CURRENT_USER_EMAIL = "currentUserEmail";
export const COOKIE_NAME = "smartmca";
export const ACH_BUILT_IN_MODE = "built-in_mode";
export const ACH_GENERIC_MODE = "generic_mode";
export const GET = "GET";
export const POST = "POST";
export const DIRECT = "DIRECT";
export const UPLOAD = "UPLOAD";
export const USERROLE = "roleName";
export const ROLE_NAME = "userRole";
export const UPDATE = "UPDATE";
export const READ = "READ";
export const TENANT_FEATURES = "features";
export const MCA_FEATURE = "mca";
export const LOAN_FEATURE = "loan";
export const DASHBOARD_FEATURE = "dashboard";
export const DEFAULT_LIST_VIEW = "default_list_view";
export const SYNDICATOR_LOGIN_FEATURE = "syndicator_login";
export const BACKGROUND_CHECK_FEATURE = "background_check";
export const RISK_ANALYSIS = "risk_analysis";
export const BANK_ACCOUNT_FEATURE = "bank_account_integration";
export const DECISION_LOGIC_FEATURE = "decision_logik";
export const BOOLEAN = "boolean";
export const IS_DEMO_USER = "is_demo_client";
export const ONE_TIME_DEBIT_SCH = "one time debit";
export const SAME_DAY_DEBIT_SCH = "same day debit";
export const TENANT_TRANSACTION_REFUNDABLE = "canTenantRefundable";
export const DEBIT_INSTRN_ACCEPTED = "Instrn Accepted";
export const METHOD_OF_MIGRATION = "methodOfMigration";

// export const JUNIOR_UNDERWRITER = "junior underwriter";
export const SCRUBBER = "scrubber";
export const SUBMISSION = "submission";

export const ADMIN = "admin";

export const SETTING_LABELS = {
  USERS: "Users",
  ROLE: "Role",
  DATA_MIGRATION: "Data Migration",
  BANK: "Bank",
  AUDIT_LOG: "Audit Log",
  BANK_BALANCE: "Bank Balance",
  BANK_ACC_BALANCE: "Bank Account Balance",
  ACH_TRANSACTION_FILES: " ACH Transaction Files",
  DEAL_COLLECTION_LOGS: "Deal Collection Logs",
  CONFIGURATION: "Configuration",
  ACH_SCHEDULER_ID_MAPPING: " ACH Scheduler ID Mapping",
  EXPERIAN_DATA: "Experian Data",
  EXPERIAN_REPORT_DATA: "Experian Report Data",
  PARTIES: "Parties",
  MCA_AGGREGATED_DATA: "MCA Aggregated Data",
  HOLIDAYS_LIST: "FED Holidays",
  EMAIL_TEMPLATES: "Email Template List",
  COLLECTION_SCHEDULE_LOGS: "Collection Schedule logs",
  COLLECTION_SCHEDULE_List: "Collection Schedule List",
  DOCUMENT_TEMPLATE_DATA_FILES: "Doc. Template Data Fields",
  DOCUMENT_TEMPLATES: "Document Templates",
};
